let config = {
  backend: process.env.REACT_APP_BACKEND_MOCK_URL,
  datagrid_license_key: process.env.REACT_APP_DATAGRID_LICENSE_KEY,
  vercelTeamId: process.env.REACT_APP_VERCEL_TEAM_ID,
  vercelToken: process.env.REACT_APP_VERCEL_TOKEN,
};

export default config;
